export default {
  path: '/',
  component: () => import('@views/Dashboard/OverView'),
  beforeEnter: (to, from, next) => {
    next()
  },
  children: [
    {
      path: '',
      name: 'home',
      //redirect: 'error/401' //  is mean force redirect to url when path is empty
      component: () => import('@/views/Home')
    },
    {
      path: 'dashboard',
      name: 'dashboard.view',
      component: () => import('@/components/ChevronTemplate')
    }
  ]
}
